import React from 'react';
import { Route } from 'react-router-dom';

// Admin & Settings pages
const SettingsPage = React.lazy(() => import('../pages/SettingsPage').then(m => ({ default: m.SettingsPage })));
const UsersPage = React.lazy(() => import('../pages/UsersPage').then(m => ({ default: m.UsersPage })));
const WebhooksPage = React.lazy(() => import('../pages/WebhooksPage').then(m => ({ default: m.WebhooksPage })));
const ReconciliationPage = React.lazy(() => import('../pages/ReconciliationPage').then(m => ({ default: m.ReconciliationPage })));
const ProcessingPage = React.lazy(() => import('../pages/ProcessingPage').then(m => ({ default: m.ProcessingPage })));

// Settings sub-pages
const CourierSettingsPage = React.lazy(() => import('../pages/CourierSettingsPage'));
const CourierPleaseSettingsPage = React.lazy(() => import('../pages/CourierPleaseSettingsPage'));
const BorderExpressSettingsPage = React.lazy(() => import('../pages/BorderExpressSettingsPage'));
const VellexSettingsPage = React.lazy(() => import('../pages/VellexSettingsPage'));
const MainfreightSettingsPage = React.lazy(() => import('../pages/MainfreightSettingsPage'));
const MYOBSettingsPage = React.lazy(() => import('../pages/MYOBSettingsPage'));
const MYOBCallbackPage = React.lazy(() => import('../pages/MYOBCallbackPage'));
const MarketplaceSettingsPage = React.lazy(() => import('../pages/MarketplaceSettingsPage'));
const ShippingConfigurationPage = React.lazy(() => import('../pages/ShippingConfigurationPage'));
const RoutingRulesPage = React.lazy(() => import('../pages/RoutingRulesPage').then(m => ({ default: m.RoutingRulesPage })));
const EmailTemplatesPage = React.lazy(() => import('../pages/EmailTemplatesPage'));

export const adminRoutes = [
  // Settings & Admin
  <Route key="/settings" path="/settings" element={<SettingsPage />} />,
  <Route key="/users" path="/users" element={<UsersPage />} />,
  <Route key="/webhooks" path="/webhooks" element={<WebhooksPage />} />,
  <Route key="/reconciliation" path="/reconciliation" element={<ReconciliationPage />} />,
  <Route key="/processing" path="/processing" element={<ProcessingPage />} />,
  
  // Settings Sub-pages
  <Route key="/settings/myob" path="/settings/myob" element={<MYOBSettingsPage />} />,
  <Route key="/myob/callback" path="/myob/callback" element={<MYOBCallbackPage />} />,
  <Route key="/settings/marketplaces" path="/settings/marketplaces" element={<MarketplaceSettingsPage />} />,
  <Route key="/settings/courier" path="/settings/courier" element={<CourierPleaseSettingsPage />} />,
  <Route key="/settings/courier/border-express" path="/settings/courier/border-express" element={<BorderExpressSettingsPage />} />,
  <Route key="/settings/courier/vellex" path="/settings/courier/vellex" element={<VellexSettingsPage />} />,
  <Route key="/settings/courier/mainfreight" path="/settings/courier/mainfreight" element={<MainfreightSettingsPage />} />,
  <Route key="/settings/shipping" path="/settings/shipping" element={<ShippingConfigurationPage />} />,
  <Route key="/settings/routing-rules" path="/settings/routing-rules" element={<RoutingRulesPage />} />,
  <Route key="/settings/email-templates" path="/settings/email-templates" element={<EmailTemplatesPage />} />,
];
